<app-header (uploadProgressToggled)="onUploadProgressToggled()"></app-header>
<app-upload-progress></app-upload-progress>
<app-left-menu></app-left-menu>
<div class="inner-page-wrapper" [class.sme-page-wrapper]="isSmeUser">
  <div class="inner-page-content">
    <ng-content />
  </div>
  <app-footer></app-footer>
</div>

<!-- DeepRoots v2 Announcement - Higher priority, appears above other popups -->
@if (showDeeprootsV2Announcement) {
  <app-popup
    heading="📢 DeepRoots v2 Released"
    confirmText="Update now"
    cancelText="Okay"
    [showCloseIcon]="false"
    (cancelClicked)="onDeeprootsV2AnnouncementAcknowledged()"
    (confirmClicked)="goToLeadsCriteria()"
  >
    <div>
      Please update your leads criteria to receive DeepRoots v2 inquiries
      matches.
    </div>
  </app-popup>
}

@if (showInfoPopup) {
  <app-info-popup
    [message]="
      '<b>Terms of Use Updated:</b><br/>Please review our latest <a href=\'/terms-of-use\' target=\'_blank\'>Terms of Use</a>.'
    "
    [autoHide]="false"
    (closed)="onInfoPopupClosed()"
  >
  </app-info-popup>
}

@if (showLeadsStatusPopup) {
  <app-update-leads-popup (closed)="onLeadsStatusPopupClosed()">
  </app-update-leads-popup>
}
